import { render, staticRenderFns } from "./StudyPlanReject.vue?vue&type=template&id=48dcf0a6&scoped=true&"
import script from "./StudyPlanReject.vue?vue&type=script&lang=js&"
export * from "./StudyPlanReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dcf0a6",
  null
  
)

export default component.exports